import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/no-danger
const DisclaimerMessage = ({disclaimerMsg}) => <p dangerouslySetInnerHTML={{__html: disclaimerMsg}} />;

DisclaimerMessage.propTypes = {
  /**
   * Message shown in disclaimer
   */
  disclaimerMsg: PropTypes.string,
};

export default DisclaimerMessage;
